<template>
  <v-btn
    viewBox="0 0 1024 1024"
    class="close-icon"
    icon
    :color="color"
    @click="handleClick"
  >
    <v-icon> mdi-close </v-icon>
  </v-btn>
</template>
<script>
/**
 * @description Componente que exibe o 'X' para fechamento
 */
export default {
  name: "CloseIcon",
  props: {
    color: {
      type: String,
      default: "black",
    },
    new: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit("action");
    },
  },
};
</script>
<style scoped>
.close-icon {
  width: 1.5rem;
  height: 1.5rem;
  transition: all 0.2s ease;
  position: relative;
}

.close-icon:hover {
  cursor: pointer;
  fill: var(--dl-color-gray-white);
}
</style>
